import React from 'react';
import Spinner from 'components/common/spinner/spinner';
import Helpers from 'utils/helpers';

export default function ButtonInput(props) {
  const hasChildren = (React.Children.count(props.children) > 0);
  const hasLabel = (props.label && !Helpers.String.isEmpty(props.label)) ? true : false;
  const hasIcon = props.iconClass ? true : false;

  const handleClick = () => {
    if (props.onClick) {
      props.onClick();
    }
  };

  const getClass = () => {
    const classNames = ['btn', props.className];
    if (!Helpers.String.isEmpty(props.variant)) {
      classNames.push(`btn-${props.variant}`);
    }
    if (!Helpers.String.isEmpty(props.size)) {
      classNames.push(`btn-${props.size}`);
    }
    if (Helpers.Object.exists(props.block)) {
      classNames.push('btn-block');
    }
    if (Helpers.Object.exists(props.circle)) {
      classNames.push('btn-circle');
    }
    if (Helpers.Object.exists(props.iconOnly) || (!hasChildren && hasIcon && !hasLabel)) {
      classNames.push('btn-icon');
    }
    return Helpers.String.join(classNames);
  };

  const renderContent = () => {
    if (props.loading) {
      return <><Spinner animation='circular' size='sm' />{props.loadingLabel || 'Loading...'}</>;
    }
    if (hasChildren) {
      return props.children;
    }
    if (hasIcon) {
      return <><i className={props.iconClass} />{props.label}</>;
    }
    return props.label;
  };

  if (props.href && !props.onClick && !props.disabled && !props.loading) {
    //render as a link
    return (
      <a className={getClass()} style={props.style} href={props.href}>
        {renderContent()}
      </a>
    );
  }
  else {
    //render as a button
    return (
      <button
        type={(props.type === 'submit') ? 'submit' : 'button'}
        className={getClass()}
        style={props.style}
        disabled={props.disabled || props.loading}
        onClick={handleClick}
        onMouseDown={(e) => e.preventDefault()}
      >
        {renderContent()}
      </button>
    );
  }
}